/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * BadRequest.ts
 */

import APIError from "./APIError";

export default class BadRequest extends APIError {
    constructor(message: string) {
        super("Bad request", 400, message);
    }
}